import React from 'react';

export const ContentPolishingLoader = ({ stage = 'generating' }) => {
  const stages = {
    generating: {
      title: 'Generating Content',
      description: 'Creating your professional content...',
      steps: [
        'Analyzing requirements',
        'Structuring content',
        'Applying best practices',
        'Generating draft'
      ]
    },
    polishing: {
      title: 'Polishing Content',
      description: 'Enhancing quality and professionalism...',
      steps: [
        'Reviewing format',
        'Enhancing clarity',
        'Optimizing structure',
        'Finalizing content'
      ]
    }
  };

  const currentStage = stages[stage];
  
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[400px] p-8">
      {/* Animated logo */}
      <div className="relative mb-8">
        <div className="absolute inset-0 rounded-full bg-primary-100 animate-ping opacity-20"></div>
        <div className="relative w-16 h-16 rounded-full bg-primary-500/10 flex items-center justify-center">
          <svg className="w-8 h-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d={stage === 'generating' 
                ? "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                : "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
              } 
            />
          </svg>
        </div>
      </div>

      {/* Title and description */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{currentStage.title}</h3>
      <p className="text-sm text-gray-600 mb-8">{currentStage.description}</p>

      {/* Progress steps */}
      <div className="space-y-4 w-full max-w-sm">
        {currentStage.steps.map((step, index) => (
          <div key={step} className="flex items-center space-x-3">
            <div className={`flex-shrink-0 h-5 w-5 rounded-full border-2 flex items-center justify-center
              ${index === 2 ? 'border-primary-500 bg-primary-50' : 'border-gray-300 bg-white'}`}>
              {index < 2 && (
                <svg className="h-3 w-3 text-primary-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <span className={`text-sm ${index === 2 ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
              {step}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}; 